import headerBackground from 'assets/images/explore-learnings/main-header-bg.png'
import menuMask from 'assets/images/explore-learnings/menu/mask-main.svg'
import sparkIcon from 'assets/images/explore-learnings/spark-icon.svg'
import sparkLogo from 'assets/images/explore-learnings/spark-logo.svg'

import { HeaderTabs } from './HeaderTabs'
import { SearchBar } from './SearchBar'
import { MASK_POSITION_CLASS, HeaderPage } from '../constants/header.constants'
import { useScrollThreshold } from '../hooks/useScrollThreshold'

interface MainHeaderProps {
  page: HeaderPage
  setPage: (page: HeaderPage) => void
  setSearchOpen?: (isOpen: boolean) => void
  onSearchStart?: () => void
}

export const MainHeader = ({ page, setPage, setSearchOpen, onSearchStart }: MainHeaderProps) => {
  const scrolled = useScrollThreshold()

  return (
    <div className="sticky -top-[126px] z-30">
      <div className="relative w-full h-[246px] flex flex-col px-20 pt-[30px] pb-3 z-20 bg-[#fafafa]">
        <div
          style={
            {
              '--image-url': `url(${headerBackground})`,
              '--mask-url': `url(${menuMask})`,
            } as React.CSSProperties
          }
          className={`absolute inset-0 -z-1 bg-[image:var(--image-url)] bg-cover bg-no-repeat
          [mask-image:linear-gradient(90deg,_rgba(0,_0,_0,_1)_calc(100%_-_1280px),_rgba(0,_0,_0,_0)_calc(100%_-_1240px)),var(--mask-url)]
          [mask-size:100%_100%,1280px_100%]
          ${MASK_POSITION_CLASS[page]}`}
        />

        <img src={sparkLogo} alt="Spark Logo" className="h-10 w-[175px]" />
        <p className="pt-4 pb-1 strong-l max-w-[478px]">Welcome to our Global Capability Hub</p>
        <p className="pb-6 body-s max-w-[364px] text-[#4C4C4C]">
          The marketeer one-stop shop for learning content & tools for accelerating growth.
        </p>
        <div className="flex justify-between w-full mt-auto">
          <div className="flex">
            <img
              src={sparkIcon}
              alt="Spark Icon"
              className={`h-[36px] w-[36px] mr-2 transition-discrete ${scrolled ? 'block' : 'opacity-0 hidden'}`}
            />
          </div>

          <HeaderTabs onChange={setPage} className="items-end" />
        </div>
      </div>

      <div className={`absolute bottom-[10px] ${scrolled ? 'left-36' : 'left-20'}`}>
        <SearchBar setIsOpen={setSearchOpen} page={page} onSearchStart={onSearchStart} />
      </div>
    </div>
  )
}
